import { Reducer, useReducer } from 'react';

export type CheckboxesState = {
  admin: boolean;
  send_pulse: boolean;
  audience: boolean;
  invite_link: boolean;
};

export type CheckboxesAction = { key: keyof CheckboxesState; checked: boolean };

const ALL_TRUE = {
  admin: true,
  send_pulse: true,
  audience: true,
  invite_link: true,
};

const ALL_FALSE = {
  admin: false,
  send_pulse: false,
  audience: false,
  invite_link: false,
};

const reducer: Reducer<CheckboxesState, CheckboxesAction> = (state, action) => {
  return {
    ...state,
    ...(action.key === 'admin' && action.checked
      ? ALL_TRUE
      : { [action.key]: action.checked }),
  };
};

export const useCheckboxes = () => useReducer(reducer, ALL_FALSE);
